import { action, makeObservable } from "mobx";
import * as React from "react";
import type { RepositoryVehicleTypes } from "../../domain/repositories/repository-vehicle-types";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { observer } from "mobx-react";
import { FormCreateVehicleType } from "../molecules/form-create-vehicle-type";
import { type UUID } from "../../utils/uuid";
import { FormUpdateVehicleType } from "../molecules/form-update-vehicle-type";
import { store } from "../../store";

export type ListCommandButtonsVehicleTypesProps = Omit<
    ListCommandButtonsProps<RepositoryVehicleTypes>,
    "list" | "createForm" | "listState"
>;

@observer
export class ListCommandButtonsVehicleTypes extends React.Component<ListCommandButtonsVehicleTypesProps> {
    constructor(props: ListCommandButtonsVehicleTypesProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteVehicleTypes(ids: UUID[]): Promise<void> {
        await store.repositoryVehicleTypes.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }

    public render(): JSX.Element {
        return (
            <ListCommandButtons
                createForm={FormCreateVehicleType}
                updateForm={FormUpdateVehicleType}
                listState={store.serviceListStates.vehicleTypes}
                {...this.props}
                onDelete={this.deleteVehicleTypes}
            />
        );
    }
}
